import { FC, useEffect, useReducer, useState } from 'react'
import React from 'react'
import * as pageUtils from './__details.utils'
import { REQUEST_CONFIGS_KEYS } from '@services/constants'
import { CheckboxList, RadioList, SelectList } from '@utils/request'
import Collapse from '@components/ui/collapse'
import Modal from '@components/ui/modal'
import * as formUtils from '@components/requestForms/__forms.utils'
import { joinClasses, makeClasses } from '@utils/styles'

import Text from '@components/ui/text'
import { populateRequestConfigsState } from '@services/store/request'
import { useAppDispatch, useAppSelector } from '@services/store'
import {
	inputReducer,
	useInitialFormState
} from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/reducer.form'
import * as pageUtilsForm from '@components/requestForms/__forms.utils'
import * as utilsList from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/__index.utils'

import Step4_1RenovationOrDevelopment from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step4_1RenovationOrDevelopment'
import Step1TypeDeDemande from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step1TypeDeDemande'
import Step2Localisation from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step2Localisation'
import Step3_1TypeUtilisation from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step3_1TypeUtilisation'
import Step5InformationsTravaux from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step5InformationsTravaux'
import Step6Branchement from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step6Branchement'
import Step4_2RequestOccupation from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step4_2RequestOccupation'
import Step4_3HomeOfficeOrBusiness from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step4_3HomeOfficeOrBusiness'
import Step3_3TypeUtilisation from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step3_3TypeUtilisation'
import Step3_4TypeUtilisation from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step3_4TypeUtilisation'
import Step4_4InstallationOfEnseigne from '@components/requestForms/GR7_industrialCommercialOrAgriculturalUsePermit/Step4_4InstallationOfEnseigne'

const IndustrialCommercialOrAgriculturalUsePermitFormDetails: FC<pageUtils.Props> =
	({ pageAssets, request }) => {
		const { incidentForm } = request
		const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
		const getLabelFromList = (list: SelectList[], value) => {
			return list?.find((element) => element.value == value?.toString())?.label
		}

		const radioListWhatToDo: RadioList[] =
			utilsList.radioListWhatToDo(pageAssets)

		const renderStep4FormCommercialPermit = (whatToDo) => {
			switch (whatToDo.toString()) {
				//* isBalconyOrPorchPermitGR6_1
				case REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
					.GR7_1RenovationOrDevelopment: {
					return (
						<Collapse
							id={4}
							buttonText={pageAssets?.request_form_renovations_informations}
							key={`request_form_renovations_informations`}
							isOpen={false}
						>
							<Step4_1RenovationOrDevelopment
								{...{
									pageAssets,
									pageUtils: pageUtilsForm,
									formInputs,
									isSummaryStep: true
									// ******
								}}
								errors={[]}
								updateInput={() => {}}
								onFixError={() => {}}
								updateCheckBoxInput={() => {}}
							/>
							<br />
						</Collapse>
					)
				}
				case REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
					.GR7_2RequestOccupation: {
					return (
						<Collapse
							id={4}
							buttonText={pageAssets?.request_form_occupation_informations}
							key={`request_form_occupation_informations`}
							isOpen={false}
						>
							<Step4_2RequestOccupation
								{...{
									pageAssets,
									pageUtils: pageUtilsForm,
									formInputs,
									isSummaryStep: true
									// ******
								}}
								errors={[]}
								updateInput={() => {}}
								onFixError={() => {}}
								updateCheckBoxInput={() => {}}
							/>
							<br />
						</Collapse>
					)
				}
				case REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
					.GR7_3HomeOfficeOrBusiness: {
					return (
						<Collapse
							id={4}
							buttonText={pageAssets?.request_form_occupation_informations}
							key={`request_form_occupation_informations`}
							isOpen={false}
						>
							<Step4_3HomeOfficeOrBusiness
								{...{
									pageAssets,
									pageUtils: pageUtilsForm,
									formInputs,
									isSummaryStep: true
									// ******
								}}
								errors={[]}
								updateInput={() => {}}
								onFixError={() => {}}
								updateCheckBoxInput={() => {}}
							/>
							<br />
						</Collapse>
					)
				}
				case REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
					.GR7_4InstallationOfEnseigne: {
					return (
						<Collapse
							id={4}
							buttonText={pageAssets?.request_form_enseigne_informations}
							key={`request_form_enseigne_informations`}
							isOpen={false}
						>
							<Step4_4InstallationOfEnseigne
								{...{
									pageAssets,
									pageUtils: pageUtilsForm,
									formInputs,
									isSummaryStep: true
									// ******
								}}
								errors={[]}
								updateInput={() => {}}
								onFixError={() => {}}
								updateCheckBoxInput={() => {}}
							/>
							<br />
						</Collapse>
					)
				}
			}
		}

		const renderStep3FormTypeUtilisation = (whatToDo) => {
			switch (whatToDo.toString()) {
				case REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
					.GR7_1RenovationOrDevelopment: {
					return (
						<Step3_1TypeUtilisation
							{...{
								pageAssets,
								pageUtils: pageUtilsForm,
								formInputs,
								isSummaryStep: true
								// ******
							}}
							errors={[]}
							updateInput={() => {}}
							formFilesInputs={[]}
							updateFileInput={() => {}}
							updateUploadedFilesMap={() => {}}
							onSetErrorFromFileComponent={() => {}}
						/>
					)
				}
				case REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
					.GR7_3HomeOfficeOrBusiness: {
					return (
						<Step3_3TypeUtilisation
							{...{
								pageAssets,
								pageUtils: pageUtilsForm,
								formInputs,
								isSummaryStep: true
								// ******
							}}
							errors={[]}
							updateInput={() => {}}
						/>
					)
				}
				case REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
					.GR7_4InstallationOfEnseigne: {
					return (
						<Step3_4TypeUtilisation
							{...{
								pageAssets,
								pageUtils: pageUtilsForm,
								formInputs,
								isSummaryStep: true
								// ******
							}}
							errors={[]}
							updateInput={() => {}}
						/>
					)
				}
			}
		}

		const dispatch = useAppDispatch()

		if (request.incidentForm) {
			dispatch(populateRequestConfigsState(request.incidentForm))
		} else {
			dispatch(populateRequestConfigsState({}))
		}

		const answers = useAppSelector((state) => state.request.configs)

		// ******************************
		// Initialize INPUTS state REDUCER
		const initialState = useInitialFormState()

		const [formInputs, dispatchFormInputs] = useReducer(
			inputReducer,
			initialState
		)

		const { whatToDo, isSameLocation } = formInputs

		// useEffect(() => {
		// 	if (answers && Object.keys(answers).length > 0) {
		// 		const initialState = useInitialFormState()
		// 		dispatchFormInputs({ type: 'RESET', payload: initialState })
		// 	}
		// }, [answers])

		return (
			<>
				{/* Question 1 */}
				<div>
					<strong>{pageAssets.request_form_what_would_you_like_to_do}</strong>
					<br />
					{/* <span>
					{getLabelFromList(radioListWhatToDo, incidentForm?.whatToDo)}
				</span> */}
					<span className={pageUtilsForm.classes.answerURB}>
						<Text
							content={getLabelFromList(radioListWhatToDo, whatToDo.value)}
						/>
					</span>
				</div>

				<p style={{ marginBottom: '20px' }}>
					<span
						onClick={() => {
							setIsModalOpen(true)
						}}
						className={pageUtils.classes.viewDetailsSpan}
					>
						<b>{pageAssets.request_form_show_details}</b>
					</span>
				</p>

				<Modal
					// cancelButtonText={pageAssets?.close_label}
					primaryButtonText={pageAssets?.close_label}
					isOpen={isModalOpen}
					onCancelBtn={() => {
						setIsModalOpen(false)
					}}
					onPrimaryButton={() => {
						setIsModalOpen(false)
					}}
					onSetIsOpen={() => {}}
					alignBtn={'left'}
					title={pageAssets?.request_form_request_details}
					showExitBtn
				>
					<div>
						<div
							style={{ marginTop: '-20px' }}
							className={joinClasses([
								pageUtils.classes.collapse,
								pageUtils.classes.summarySubTitles
							])}
						>
							<>
								<Collapse
									id={1}
									buttonText={pageAssets?.request_form_type_de_demandes}
									key={`request_form_type_de_demandes`}
									isOpen={false}
								>
									<Step1TypeDeDemande
										{...{
											pageAssets,
											pageUtils: pageUtilsForm,
											formInputs,
											isSummaryStep: true
											// err[],
											// ()=>{},
											// ()=>{}
										}}
										errors={[]}
										updateInput={() => {}}
										onFixError={() => {}}
									/>

									<br />
								</Collapse>
								<Collapse
									id={2}
									buttonText={pageAssets?.request_form_request_location}
									key={`request_form_request_location`}
									isOpen={false}
								>
									<Step2Localisation
										{...{
											pageAssets,
											pageUtils: pageUtilsForm,
											formInputs,
											isSummaryStep: true,
											// ******
											isAddressOutsideLaval: false
											// showAdresseBlock:
											// 	isSameLocation?.toString() == 'false' ? true : false
										}}
										showAdresseBlock={
											isSameLocation?.value?.toString() == 'false'
												? true
												: false
										}
										errors={[]}
										updateInput={() => {}}
										onFixError={() => {}}
										inputs={[]}
										onSetInputs={() => {}}
										formFilesInputs={[]}
										updateFileInput={() => {}}
										updateUploadedFilesMap={() => {}}
										onSetErrorFromFileComponent={() => {}}
										applicantLocation={request.incidentForm?.applicant}
									/>

									<br />
								</Collapse>
								{(whatToDo.value?.toString() ==
									REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
										.GR7_1RenovationOrDevelopment ||
									whatToDo.value?.toString() ==
										REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
											.GR7_3HomeOfficeOrBusiness ||
									whatToDo.value?.toString() ==
										REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
											.GR7_4InstallationOfEnseigne) && (
									<Collapse
										id={3}
										buttonText={pageAssets?.request_form_type_of_use}
										key={`request_form_type_of_use`}
										isOpen={false}
									>
										<>{renderStep3FormTypeUtilisation(whatToDo.value)}</>
										<br />
									</Collapse>
								)}

								{/* Render the appropriate form for commercial permit work based on the value of 'whatToDo' */}
								{/***   ! important  ***/}
								{renderStep4FormCommercialPermit(whatToDo.value)}

								{whatToDo.value?.toString() ==
									REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
										.GR7_1RenovationOrDevelopment && (
									<Collapse
										id={5}
										buttonText={
											pageAssets?.request_form_information_on_the_work
										}
										key={`request_form_information_on_the_work`}
										isOpen={false}
									>
										<Step5InformationsTravaux
											{...{
												pageAssets,
												pageUtils: pageUtilsForm,
												formInputs,
												isSummaryStep: true
												// ******
											}}
											errors={[]}
											updateInput={() => {}}
											onFixError={() => {}}
										/>

										<br />
									</Collapse>
								)}

								{whatToDo.value?.toString() ==
									REQUEST_CONFIGS_KEYS.whatToDoCommercialPermit
										.GR7_1RenovationOrDevelopment && (
									<Collapse
										id={6}
										buttonText={
											pageAssets?.request_form_branching_aqueduc_egouts
										}
										key={`request_form_branching_aqueduc_egouts`}
										isOpen={false}
									>
										<Step6Branchement
											{...{
												pageAssets,
												pageUtils: pageUtilsForm,
												formInputs,
												isSummaryStep: true
												// ******
											}}
											errors={[]}
											updateInput={() => {}}
											onFixError={() => {}}
											updateCheckBoxInput={() => {}}
										/>

										<br />
									</Collapse>
								)}
							</>
						</div>
					</div>
				</Modal>
			</>
		)
	}

export default IndustrialCommercialOrAgriculturalUsePermitFormDetails
